





































































import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {PartnerType, ReceiptExpensesPickingListTargetType, ReceiptPaymentType} from "@/enums/type";
import {cloneDeep} from "lodash";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import {ReceiptPartnerStore} from "@/modules/receiptsexpenses/receiptpartner/store";
import {ReceiptPartnerParams} from "@/modules/receiptsexpenses/receiptpartner/params";
import {DebtEmployee} from "@/interfaces/entity";
import {union, difference} from "lodash";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import ReceiptDebtPartnerTable
    from "@/modules/receiptsexpenses/receiptpartner/Form/components/ReceiptDebtPartnerTable/index.vue";
import ConfirmReceiptExpense from "@/modules/receiptsexpenses/shared/components/ConfirmReceiptExpense/index.vue";
import {PartnerStore} from "@/modules/partners/store";
import PrintReceiptExpense from "@/modules/receiptsexpenses/shared/components/PrintReceiptExpense/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import UploadExcel, {ExcelData} from "@/shared/components/UploadExcel/index.vue";
import {MAPPING_RECEIPT_PARTNER_EXCEL} from "@/shared/constant";
import ReceiptPartnerPickingListPrint from "@/modules/receiptsexpenses/receiptpartner/shared/Print/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

const form = {
    paymentType: undefined,
    debtIds: [] as any,
    partnerRowGuid: undefined,
    note: undefined,
    bankAccount: undefined
};

@Component({
    name: "ReceiptPartnerForm",
    components: {
        AInputBarCode,
        ReceiptPartnerPickingListPrint,
        UploadExcel,
        PrintReceiptExpense,
        ConfirmReceiptExpense, ReceiptDebtPartnerTable, PartnerSelector, LadingPaymentTypeLabel, EnumSelector
    }
})
export default class extends Vue {
    ReceiptPaymentType = ReceiptPaymentType;
    form = cloneDeep(form);
    ladingCode = "";
    selectedIds: number[] = [];
    isSaving = false;
    PartnerType = PartnerType;
    visibleConfirm = false;

    receiptPickingListId = null as any;
    printObj = {
        id: "receipt-partner-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    }

    ladingCodes = [] as any;

    created() {
        ReceiptPartnerStore.clearDebtPartnerStore();
    }

    @Watch("form.partnerRowGuid")
    onChangePartnerRowGuid(val: any) {
        this.form.debtIds = [];
        if (!val) return;
        ReceiptPartnerStore.listDebtPartner({...new ReceiptPartnerParams(), targetRowGuid: val, limit: 2000});
    }

    onChangeLadingCode(evt: any) {
        const val = evt?.target?.value;
        const debtIds: number[] = this.debtPartners
            .filter((debt: DebtEmployee) => debt.billLading?.ladingCode === val)
            .map((debt: DebtEmployee) => debt.id);
        this.form.debtIds = union(this.form.debtIds, debtIds) as any;
        setTimeout(() => this.ladingCode = "", 500);
    }

    get totalMoney() {
        return this.debtPartners
            .filter((debt: DebtEmployee) => this.form.debtIds.includes(debt.id as any))
            .reduce((previousValue, currentValue) => (previousValue + currentValue.money || 0), 0);
    }

    get totalBillLading() {
        return this.form.debtIds.length;
    }

    get debtPartners() {
        return ReceiptPartnerStore.ids.map((id: number) => ReceiptPartnerStore.data[id]);
    }

    get dataConfirm() {
        const debts = this.form.debtIds.map((id: number) => ReceiptPartnerStore.data[id]);
        const totalMoney = debts.reduce((prev, current: DebtEmployee, index, array) => {
            const money = current?.money
            return prev + (money ? money : 0)
        }, 0);
        const target = {
            type: ReceiptExpensesPickingListTargetType.Partner,
            name: this.form.partnerRowGuid ? PartnerStore.data[this.form.partnerRowGuid as any]?.name : ''
        }
        return {
            debts,
            target,
            totalMoney,
            isExpense: false,
        }
    }

    onSelectedIdsChange(selectedIds: any) {
        this.form.debtIds = selectedIds;
    }

    async onSave() {
        try {
            if (!this.isValidForm()) return;
            this.isSaving = true;
            const data = await ReceiptPartnerStore.receiptPartner(this.form);
            this.receiptPickingListId = data.id;
            this.$message.success("Thu tiền đối tác thành công");
            (this.$refs.printReceiptExpense as any).$el.click();
            this.refresh();
        } catch (e) {
            console.log(e);
            this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
        }
        this.isSaving = false;
        this.visibleConfirm = false;
    }

    confirm() {
        if (!this.isValidForm()) return;
        this.visibleConfirm = true;
    }

    isValidForm() {
        if (!this.form.partnerRowGuid) {
            this.$message.error("Vui lòng chọn đối tác");
            return false;
        }
        if (!this.form.debtIds.length) {
            this.$message.error("Vui lòng quét mã vận đơn để thu");
            return false;
        }
        if (!this.form.paymentType) {
            this.$message.error("Vui lòng chọn hình thức thanh toán");
            return false;
        }
        return true;
    }

    refresh() {
        this.ladingCode = "";
        this.form = cloneDeep(form);
        ReceiptPartnerStore.clearDebtPartnerStore();
    }

    onSuccessUpload(excelData: ExcelData) {
        if (!this.isValidFileExcel(excelData.header)) return;
        this.ladingCodes = this.mapToJson(excelData.header, excelData.results);
        this.form.debtIds = this.debtPartners
            .filter((debt: DebtEmployee) => this.ladingCodes.includes(debt.billLading.ladingCode))
            .map((debt: DebtEmployee) => debt.id) as any;
    }

    isValidFileExcel(header) {
        if (!header || !Array.isArray(header) || header.length !== Object.keys(MAPPING_RECEIPT_PARTNER_EXCEL).length) {
            this.$message.error("File excel bị lỗi");
            return false;
        }
        for (let i = 0; i < header.length; i++) {
            if (!Object.keys(MAPPING_RECEIPT_PARTNER_EXCEL).includes(header[i])) {
                this.$message.error("File excel bị lỗi");
                return false;
            }
        }
        return true;
    }

    mapToJson(header: Array<string>, results: Array<any>) {
        const mapResults: any = [];
        results.forEach((item: any, index: number) => {
            header.forEach((key: string) => {
                const trueKey = MAPPING_RECEIPT_PARTNER_EXCEL[key];
                if (trueKey) {
                    mapResults.push(item[key]?.toString());
                }
            });
        })
        return mapResults;
    }

    acceptDebt() {
        const deletedDebtPartnerIds = difference(ReceiptPartnerStore.ids, this.form.debtIds);
        ReceiptPartnerStore.deleteDebtPartnerByIds(deletedDebtPartnerIds);
    }
}
